import { defineStore } from 'pinia';

export const useAdminStore = defineStore('Admin', {
  state: () => ({
    selectedTab: 'TabReports',
    lastScrollPosition: 0,
	  tabs: new Map([
		  ['relacje', 'TabCommentaries'],
		  ['gale', 'TabGalas'],
		  ['zawodnicy', 'TabCompetitors'],
		  ['analityka-klikniec', 'TabAnalytics'],
		  ['dziennikarze', 'TabJournalists'],
		  ['progres-druzyn', 'TabLastSeasonComparison'],
		  ['relacje-dodatkowe', 'TabAdditionalCommentaries'],
		  ['zgloszenia', 'TabReports'],
		  ['bukmacherzy', 'TabBookmakers'],
		  ['autorzy', 'TabAuthors'],
		  ['federacje', 'TabFederations'],
		  ['popupy', 'TabPopUps'],
		  ['kupony', 'TabCoupons'],
		  ['ligi', 'TabLeagues'],
		  ['druzyny', 'TabTeams'],
		  ['reprezentacje', 'TabRepresentations'],
		  ['porownania', 'TabTeamComparisons'],
		  ['koszulki', 'TabBookmakerShirts'],
		  ['dyscypliny', 'TabDisciplineRankings'],
		  ['analityka-odwiedzin', 'TabVisitAnalytics'],
		  ['strony-statystyk', 'TabStats'],
		  ['statystyki-odwrocone', 'StatsPage'],
		  ['moderacja-komentarzy', 'TabCommentsModeration'],
			['mecze', 'TabMatches'],
			['reklamywtd', 'TabBetAds'],
			['notifications', 'TabNotifications'],
			['typers', 'TabTypers'],
			['suppi', 'TabSuppiUsers'],
			['shortcodes', 'TabShortcodes'],
			['url-shortcuts', 'TabUrlShortcuts'],
			['ciekawe-staty', 'TabInterestingStats'],
			['emails', 'TabEmails'],
			['sidebar-bonuses', 'TabSidebarBonuses'],
			['affiliates', 'TabAffiliates'],
	  ])
  }),
  getters: {

  },
  actions: {
		getKey(val) {
			return [...this.tabs].find(([key, value]) => val === value)[0];
		},
    changeTab(tabName) {
      if (this.selectedTab === 'TabReports' && tabName !== 'TabReports') {
        this.lastScrollPosition = window.scrollY;
      }
      this.selectedTab = tabName;
	    window.location.hash = this.getKey(tabName);
    },
  },
});